import axios from 'axios';
import store from './store';
import { safeRedirect } from '@/helper/helper';

const instance = axios.create();

instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => response,
    error => {
        // expired token or blocked account: back to the login page (the login request itself shows its own error)
        const isLogin = error.config && /\/auth\/login$/.test(error.config.url || '');
        if (error.response && error.response.status === 401 && !isLogin) {
            store.dispatch('logout');
            // back to the same page after logging in again (only a page of this app; the login page checks it again)
            const here = safeRedirect(window.location.pathname + window.location.search);
            window.location.assign(here !== '/' ? `/login?redirect=${encodeURIComponent(here)}` : '/login');
        }
        return Promise.reject(error);
    }
);

export default instance;
